import { Box } from "@mui/material";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { ImpersonationBanner } from "@/features/impersonation";
import { AuthGuard } from "@/lib/keycloak/auth-guard";

export const Route = createFileRoute("/onboarding/_guarded")({
	component: GuardedOnboardingLayout,
});

function GuardedOnboardingLayout() {
	return (
		<AuthGuard>
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					zIndex: 1200,
				}}
			>
				<ImpersonationBanner />
			</Box>
			<Outlet />
		</AuthGuard>
	);
}
